document.addEventListener('DOMContentLoaded', () => {
  new Swiper('.js-interviewSwiper', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 24,
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      576: {
        slidesPerView: 2,
      },
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  const documentsSwiper = new Swiper('.js-documentsSwiper', {
    loop: false,
    slidesPerView: 1,
    delay: 2000,
    spaceBetween: 24,
    mousewheel: true,
    pagination: {
      el: '.swiper-pagination2',
      type: 'fraction', // 枚数表示
      clickable: true,
      formatFractionCurrent: function (number) {
        if (number < 10) {
          return '0' + number;
        } else {
          return number;
        }
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
    },
  });

  document.querySelectorAll('.js-documents__slider-next-item').forEach((slide) => {
    slide.addEventListener('click', () => {
      documentsSwiper.slideNext();
    });
  });

  document.querySelectorAll('.js-documents__slider-prev-item').forEach((slide) => {
    slide.addEventListener('click', () => {
      documentsSwiper.slidePrev();
    });
  });
});
